<template>
    <v-row>
        <v-col :cols="$slots.button ? 5 : 6">
            <v-text-field :rules="[...rules, $rules.alphabetical]" v-model="surnames"
                :label="label ? `Apellidos del ${label}` : 'Apellidos'" variant="outlined"></v-text-field>
        </v-col>
        <v-col :cols="$slots.button ? 5 : 6">
            <v-text-field :rules="[...rules, $rules.alphabetical]" v-model="givenNames"
                :label="label ? `Nombre del ${label}` : 'Nombre'" variant="outlined"></v-text-field>
        </v-col>

        <v-col v-if="$slots.button" cols="2">
            <template v-if="$slots.button">
                <slot name="button"></slot>
            </template>
        </v-col>
    </v-row>
</template>
<script>

export default {

    name: 'v-full-name',

    props: {
        modelValue: {
            type: String
        },

        rules: {
            type: Array,
            default: () => []
        },

        label: {
            type: String,
        }
    },

    mounted() {
        if (this.modelValue) {
            this.surnames = this.modelValue?.split(',')[0] || '';
            this.givenNames = this.modelValue?.split(',')[1] || '';
        }
    },

    data() {
        return {
            surnames: '',
            givenNames: ''
        };
    },

    computed: {
        fullName() {
            return `${this.surnames}, ${this.givenNames}`;
        }
    },

    watch: {
        fullName: function (newVal) {
            this.$emit('update:modelValue', newVal);
        },

        surnames(newVal) {
            if (!newVal) {
                this.surnames = '';
            }
        },

        givenNames(newVal) {
            if (!newVal) {
                this.givenNames = '';
            }
        }
    }
}
</script>